var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.printResponse}},[_c('v-icon',{staticClass:"tw-mr-2",attrs:{"size":"16","color":"primary"}},[_vm._v(" fas fa-print ")]),_vm._v(" "+_vm._s(_vm.$t(`fe_common.text_print`))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }